// @flow
// Types
import type {
  Action,
} from 'fc-flow-types/redux'

type Reducer<S> = (state: S, payload: any, action?: Action<any>) => S
type ReducerMap<S> = { [key: string]: Reducer<S> }

export const RESET_STORE = 'RESET_STORE'

export default function createReducer<S> (
  initialState: S,
  reducerMap: ReducerMap<S>,
  resetReducer: S = {[RESET_STORE]: (): S => initialState}
): (state: S, action: Action<any>) => S {
  const finalMap = {
    ...reducerMap,
    ...resetReducer,
  }
  return (state: S = initialState, action: Action<any>): S => {
    const reducer: ?Reducer<S> = finalMap[action.type]

    if (reducer) {
      return reducer(state, action.payload, action)
    }

    return state
  }
}
